import React, { Component } from 'react'
import Scene3dAnimation from 'lib/Scene3dAnimation'
import PropTypes from 'prop-types'
import { TweenMax, Power0, Power1, Power2 } from 'gsap'
// import SplitText from 'lib/SplitText'
import SceneCopyContainer from 'containers/SceneCopyContainer'
import $ from 'jquery'
import { createMarkup, contentWidth } from 'lib/Utils'
import Swipeable from 'react-swipeable'
import 'babel-polyfill'

import BullteNav from 'containers/BulletNav'
import './index.scss'

import katex from 'katex'
import 'katex/dist/katex.css'

import dots01 from 'assets/images/dots.01.svg'
import dots02 from 'assets/images/dots.02.svg'
import dots03 from 'assets/images/dots.03.svg'
import dots04 from 'assets/images/dots.04.svg'
import dots05 from 'assets/images/dots.05.svg'
import dots06 from 'assets/images/dots.06.svg'
import dots07 from 'assets/images/dots.07.svg'
import dots08 from 'assets/images/dots.08.svg'
import dots09 from 'assets/images/dots.09.svg'
import dots10 from 'assets/images/dots.10.svg'

require('jquery-mousewheel')

const dots = [dots01, dots02, dots03, dots04, dots05, dots06, dots07, dots08, dots09, dots10]

class Scene3d extends Component {
  constructor (props) {
    super(props)
    this.state = { allowNavigation: true }
    this.formulae = {}
    this.onMousewheelCallback = this.onMousewheelCallback.bind(this)
    this.onSwipedCallback = this.onSwipedCallback.bind(this)
  }

  componentDidMount () {
    // Init 3d scene animation
    this.scene3dAnimation = new Scene3dAnimation()
    this.scene3dAnimation.init()

    this.formulae.active = this.formulae.icosahedron
    TweenMax.staggerFromTo($(this.formulae.active).find('.base').children(), 0.4, { autoAlpha: 0 }, { autoAlpha: 1 }, 0.1)
    // $(this.formulae.wrapper).children().each((i, el) => {
    //   TweenMax.staggerTo($(el).find('.base').children(), 2, { y: '10px', repeat: -1, yoyo: true, ease: Power1.easeInOut }, 0.1)
    // })

    $(this.el).on('mousewheel', this.onMousewheelCallback)

    TweenMax.staggerFromTo(
      $(this.dots).find('img'),
      2,
      { opacity: 0 },
      { opacity: 0.7, ease: Power0.easeNone, repeat: -1, yoyo: true },
      1.5
    )
  }

  getServiceIndex (serviceID) {
    return this.props.listedServices.findIndex((service) => { return service.ID === serviceID })
  }

  getAdjacentServiceID (next = true) {
    const serviceIndex = this.getServiceIndex(this.props.selectedService)
    let id = null

    if (next) {
      if (serviceIndex === -1) {
        id = this.props.listedServices[0].ID
      } else if (serviceIndex + 1 !== this.props.listedServices.length) {
        id = this.props.listedServices[serviceIndex + 1].ID
      }
    } else {
      if (serviceIndex === -1) {
        id = this.props.listedServices[this.props.listedServices.length - 1].ID
      } else if (serviceIndex !== 0) {
        return this.props.listedServices[serviceIndex - 1].ID
      }
    }

    return id
  }

  isGestureNavAllowed () {
    return this.state.allowNavigation && this.props.listedServices.length > 0 && this.props.isHome
  }

  onMousewheelCallback (event) {
    if (!this.isGestureNavAllowed()) return
    const next = (event.deltaFactor * event.deltaY < 0)
    this.props.selectService(this.getAdjacentServiceID(next))
  }

  onSwipedCallback (dir) {
    if (!this.isGestureNavAllowed()) return
    const next = ['up', 'left'].includes(dir)
    this.props.selectService(this.getAdjacentServiceID(next))
  }

  componentDidUpdate (prevProps, prevState) {
    // For sliding the whole scene between homepage and any other page
    if (this.props.slide) {
      TweenMax.to(
        this.el,
        0.8,
        { x: `${((window.innerWidth / 2) - ((window.innerWidth - contentWidth()) / 2)) * -1}px`, ease: Power2.easeInOut }
      )
    } else {
      TweenMax.to(this.el, 0.8, { x: '0px', ease: Power2.easeInOut })
    }

    if (prevProps.siteMenuVisible !== this.props.siteMenuVisible) {
      if (this.props.siteMenuVisible) {
        this.scene3dAnimation.burstCurrentShape()
      } else {
        if (prevProps.selectedServiceKey === this.props.selectedServiceKey && this.state.allowNavigation) {
          this.scene3dAnimation.joinCurrentShape()
        }
      }
    }

    if (prevProps.isHome !== this.props.isHome) {
      this.scene3dAnimation.toggleCameraRotation(this.props.isHome)
    }
  }

  transitionToFormula (key) {
    TweenMax.staggerFromTo($(this.formulae.active).find('.base').children(), 0.1, { autoAlpha: 1 }, { autoAlpha: 0 }, 0.1)
    TweenMax.staggerFromTo($(this.formulae[key]).find('.base').children(), 0.1, { autoAlpha: 0 }, { autoAlpha: 1 }, 0.1)
    this.formulae.active = this.formulae[key]
  }

  componentWillReceiveProps (nextProps) {
    // Transition between shapes
    if (nextProps.selectedServiceKey !== this.props.selectedServiceKey && this.state.allowNavigation) {
      this.setState({ allowNavigation: false })
      this.scene3dAnimation
        .transitionToShape(nextProps.selectedServiceKey)
        .then(() => {
          this.setState({ allowNavigation: true })
        })
      this.transitionToFormula(nextProps.selectedServiceKey)
    }
  }

  render () {
    return (
      <Swipeable
        onSwipedUp={() => this.onSwipedCallback('up')}
        onSwipedRight={() => this.onSwipedCallback('right')}
        onSwipedDown={() => this.onSwipedCallback('down')}
        onSwipedLeft={() => this.onSwipedCallback('left')}
        trackMouse>
        <div ref={el => { this.el = el; return false }} className='scene-wrapper'>
          <div ref={el => { this.formulae.wrapper = el }} className='math-formulae'>
            <div
              ref={el => { this.formulae.icosahedron = el }}
              className='formula-icosahedron'
              dangerouslySetInnerHTML={createMarkup(katex.renderToString('H_c=-\\int p(x)\\log\\frac{p(x)}{m(x)}\\,dx'))} />
            <div
              ref={el => { this.formulae.box = el }}
              className='formula-box'
              dangerouslySetInnerHTML={createMarkup(katex.renderToString('\\int p(x)f_k(x)dx = F_k'))} />
            <div
              ref={el => { this.formulae.torusKnot = el }}
              className='formula-torusKnot'
              dangerouslySetInnerHTML={createMarkup(katex.renderToString('P(A\\mid B) = \\frac{P(B \\mid A) \\, P(A)}{P(B)}'))} />
            <div
              ref={el => { this.formulae.platonic = el }}
              className='formula-platonic'
              dangerouslySetInnerHTML={createMarkup(katex.renderToString('\\sum_i{P(A_i  |  B)} = 1'))} />
            <div
              ref={el => { this.formulae.torus = el }}
              className='formula-torus'
              dangerouslySetInnerHTML={createMarkup(katex.renderToString('F_2 = m_2 a_2 = \\frac{m_2 k_2}{r^2} i_2'))} />
            <div
              ref={el => { this.formulae.cone = el }}
              className='formula-cone'
              dangerouslySetInnerHTML={createMarkup(katex.renderToString('f_Y(y) = \\int_{-\\infty}^\\infty f_Y(y\\mid X=\\xi )\\,f_X(\\xi)\\,d\\xi'))} />
            <div
              ref={el => { this.formulae.octahedron = el }}
              className='formula-octahedron'
              dangerouslySetInnerHTML={createMarkup(katex.renderToString('P(x) = 2^{-L(x)}'))} />
            <div
              ref={el => { this.formulae.frame = el }}
              className='formula-frame'
              dangerouslySetInnerHTML={createMarkup(katex.renderToString('T_n(R(K_i)) = x'))} />
          </div>
          <div className='dots' ref={el => { this.dots = el }}>
            <div className='dots__inner'>
              {
                dots.map((dotsImage, index) => { return <img key={`dotsImage${index}`} src={dotsImage} /> })
              }
            </div>
          </div>
          <div id='scene3d' />
          <SceneCopyContainer isHome={this.props.isHome} />
          {
            (this.props.isHome && !this.props.siteMenuVisible) &&
            <BullteNav allowNavigation={this.state.allowNavigation} />
          }
        </div>
      </Swipeable>
    )
  }
}

Scene3d.propTypes = {
  slide: PropTypes.bool,
  selectedServiceKey: PropTypes.string,
  selectService: PropTypes.func,
  selectedService: PropTypes.number,
  listedServices: PropTypes.array,
  isHome: PropTypes.bool,
  siteMenuVisible: PropTypes.bool
}

export default Scene3d



// WEBPACK FOOTER //
// ./src/components/Scene3d/index.js